<div *ngIf="configFiltersList.length > 0" class="d-flex flex-column user-menu mb-5">
  @for (item of configFiltersList; track item) { @switch (item.name) { @case ('pageHeader') {
  <div class="mb-3">
    <ui-fh-page-header [title]="configFilters.title" [description]="configFilters.description"></ui-fh-page-header>
  </div>
  } @case ('menu') {
  <div class="content">
    <ui-fh-menu [items]="item.items" [header]="false" [sticky]="false"></ui-fh-menu>
  </div>
  } @case ('form') {
  <div class="content">
    <div class="row sim-padding">
      <ng-container>
        @for (formItem of item.formItems; track formItem) { @switch (formItem.type) { @case ('dropdown') {
        <div *ngIf="formItem.dividerLabel" class="divider p-0 mb-4">
          <hr class="line" />
          <span class="label">{{ formItem.dividerLabel | translate }}</span>
          <hr class="line" />
        </div>
        <ui-fh-dropdown
          class="mb-2 p-0"
          [defaultValue]="getDefaultValue(formItem.formControl, formItem?.defaultValue)"
          [labelConfigs]="{ label: formItem.label }"
          [placeholder]="formItem.placeHolder | translate"
          (valueChange)="saveValues($event, formItem.formControl)"
          [list]="formItem.dropDownOptions!"
          [borderClass]="true"></ui-fh-dropdown>
        } @case ('switch') {
        <div *ngIf="formItem.dividerLabel" class="divider p-0 mt-4 mb-4">
          <hr class="line" />
          <span class="label">{{ formItem.dividerLabel | translate }}</span>
          <hr class="line" />
        </div>
        <ui-fh-card class="px-0" [innerClass]="'p-2'" [outerClass]="'p-0 mb-2'">
          <ui-fh-input-switch
            [defaultValue]="getDefaultValue(formItem.formControl)"
            (valueChange)="saveValues($event, formItem.formControl)"
            [labelConfigs]="{ label: formItem.label, class: 'ms-0' }"></ui-fh-input-switch>
        </ui-fh-card>
        } } }
      </ng-container>
    </div>
  </div>
  } } }
</div>
